import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_get_current_date_from_utcService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async get(inParams: { utcDate: string, timezone?: string, warehouseId?: number }): Promise<{ result?: { id?: number, convertedDate?: string } }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.utcDate)) {
      missingRequiredInParams.push('\'utcDate\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_current_date_from_utc/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      utcDate: string, timezone?: string, warehouseId?: number    }) {
        if(isNil(inParams.utcDate)) {
          return true; 
        }
      return false;
    }
}
